import { State } from 'app/types/redux-types'
import { createReduxSlice } from '../../../ReduxSlice'
import { fetchMasterDataAsync } from './masterDataAsync'
import { AppConfig } from 'app/types/types'

const initialState: State<AppConfig> = {
  data: {} as AppConfig,
  status: 'idle',
  error: null
}

const appConfigSlice = createReduxSlice({
  name: 'apiData',
  initialState,
  asyncThunks: {
    fetchMasterData: fetchMasterDataAsync
  },
  reducers: {
    reset: state => {
      state.data = { ...initialState.data, frontLineConfig: undefined, profile: undefined, settings: undefined }
      state.status = initialState.status
      state.error = initialState.error
      state.errorDetails = undefined
    }
  }
})

export const { fetchMasterData, reset: resetConfigData } = appConfigSlice.actions
export default appConfigSlice.reducer
